<div style="height: inherit;"  *ngIf="isInitalDataLoaded">
  <app-litmus-header [showCalendarButton]="true" [showUserButton]="true" [showChangeAccessLevelButton]="true"></app-litmus-header>
  <!-- <app-side-bar></app-side-bar> -->
  <app-side-bar-v2></app-side-bar-v2>
  <app-ltms-download-widget></app-ltms-download-widget>
  <app-ltms-custom-field-render></app-ltms-custom-field-render>
  <!-- Placed here global filter side bar popup -->
  <app-ltms-global-filter-side-bar></app-ltms-global-filter-side-bar>
  <div class="main-container" id="projectRouterOutlet">
    <div class="container-fluid child-container" [class.loading]="!isInitalDataLoaded" >
      <app-ltms-global-filter-draw></app-ltms-global-filter-draw>
      <router-outlet></router-outlet>
    </div>
    <app-litmus-footer [isAccount]="false"></app-litmus-footer>
  </div>
</div>
<div class="ltms-loading" *ngIf="!isInitalDataLoaded">
  <app-ltms-loader></app-ltms-loader>
</div>
<div class="modal modal-dialog-centered other-project-dedect-popup" id="sessionTimeOut" role="dialog" *ngIf="showModel">
  <div class="modal-dialog" role="document">
    <div class="modal-content usr-setting-pop-up-field">
      <div class="modal-header">
        <span class="modal-title other-project-dedect-pop-up-header">
          Session update detected
        </span>
        <!-- <button type="button" class="btn-close" (click)="closeModal()"></button> -->
      </div>
      <div class="modal-body other-project-dedect-pop-up-summary">
        You’re active in another session. Please choose an action to proceed.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn other-project-detect-pop-up-switch-btn" (click)="continueToThisProject()">
            Continue with current selection
        </button>
        <button type="button" class="btn other-project-detect-pop-up-switch-btn" (click)="loadTheActiveSessionProject()">
            Load the latest project here
        </button>
       
    </div>
    </div>
  </div>
</div>
